import React from 'react';
import Icon from '../../../components/AppIcon';

const CalendarStats = ({ totalPosts, completedMonths, upcomingPosts }) => {
  const stats = [
    {
      label: 'Total Posts Planned',
      value: totalPosts,
      icon: 'FileText',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      label: 'Months Completed',
      value: completedMonths,
      icon: 'CheckCircle',
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    },
    {
      label: 'Upcoming Posts',
      value: upcomingPosts,
      icon: 'Clock',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-6">
      {stats?.map((stat, index) => (
        <div 
          key={index}
          className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-sm hover:shadow-md transition-all duration-250"
        >
          <div className="flex items-center gap-4">
            <div className={`w-12 h-12 md:w-16 md:h-16 rounded-lg ${stat?.bgColor} flex items-center justify-center flex-shrink-0`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
            <div className="min-w-0">
              <p className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground">{stat?.value}</p>
              <p className="text-xs md:text-sm text-muted-foreground font-caption mt-1">{stat?.label}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CalendarStats;